export const ANALYTICS_SCHEMA_URLS = {
  LOG_CLIENT_ERROR: 'iglu:com.psp/casino_log_client_error/jsonschema/1-0-0',
  PLAY_GAME_CLICK: 'iglu:com.psp/casino_play_game_click/jsonschema/3-0-0',
  PLAY_DEMO_GAME_CLICK: 'iglu:com.psp/casino_demo_game_click/jsonschema/2-0-0',
  MORE_GAME_CLICK: 'iglu:com.psp/casino_more_game_click/jsonschema/3-0-0',
  ADD_FAVORITE_CLICK: 'iglu:com.psp/casino_add_favorite_click/jsonschema/2-0-0',
  ALL_CLASSIFICATION_CLICK:
    'iglu:com.psp/casino_all_classification_click/jsonschema/2-0-0',
  NAVIGATION_CLICK: 'iglu:com.psp/casino_navigation_click/jsonschema/3-0-0',
  BONUS_ACTIONS: 'iglu:com.psp/casino_bonus_item_click/jsonschema/2-0-0',
  WAGERING_CLICK: 'iglu:com.psp/casino_wagering_click/jsonschema/3-0-0',
  CONTEXT_CASINO_PARAMETERS:
    'iglu:com.psp/context_casino_parameters/jsonschema/1-1-0',
  CONTEXT_EVENT_LOCATION:
    'iglu:com.psp/context_event_location/jsonschema/1-2-0',
  GAME_ACTION: 'iglu:com.psp/casino_game_action/jsonschema/3-0-0',
};

export const ANALYTICS_SCREEN_NAMES = {
  ERROR: 'live_casino_error',
  MAIN: 'live_casino_main',
  BONUS: 'live_casino_bonus_page',
  DETAIL_CATEGORY: 'live_casino_detail_category',
  DETAIL_THEME: 'live_casino_detail_theme',
  DETAIL_PROVIDER: 'live_casino_detail_provider',
  RECENT_PROVIDER: 'live_casino_detail_recent',
  FAVORITE: 'live_casino_favorite',
  GAME_PREVIEW: 'live_casino_game_preview',
  OPEN_GAME: 'live_casino_open_game',
  SEARCH_PAGE: 'live_casino_search_page',
  ALL_CATEGORY: 'live_casino_all_category',
  ALL_THEME: 'live_casino_all_theme',
  ALL_PROVIDER: 'live_casino_all_provider',
  HALL_OF_FAME: 'live_casino_hall_of_fame',
  COLLECTING_GAMES: 'live_casino_collecting_page',
  WAGERING: 'live_casino_wagering_page',
  BONUS_COLLECTION: 'live_casino_bonus_collection',
  RULES: 'live_casino_how_to_play_page',
  OPEN_RULE: 'live_casino_open_how_to_play_page',
  PROMO: 'live_casino_promo_page',
  OPEN_PROMO: 'live_casino_open_promo_page',
  RECENT_GAMES: 'live_casino_recent_games',
  BONUS_WAGERING: 'instant_wagering',
  SITEWIDE_NAVBAR: 'sitewide_navbar',
};

export const ANALYTICS_SCREEN_AREAS = {
  CARD_LIST: 'card_list',
  GAME_LIST: 'game_list',
  WIDGET: 'widget',
  SIDEBAR: 'sidebar',
  POP_UP: 'pop_up',
  BUTTON: 'button',
  CONTROL_TAB: 'control_tab',
  HEADER: 'header',
  SEARCH_GAME_LIST: 'search_game_list',
  SEARCH_CATEGORY_GAME_LIST: 'search_category_game_list',
  GAME_WINDOW: 'game_window',
  BONUS_TILE_LIST: 'bonus_tile_list',
  BONUS_DETAIL: 'bonus_detail',
  WAGERING_BAR: 'wagering_bar',
  CATEGORY_LIST: 'category_list',
  PROVIDER_LIST: 'provider_list',
  PROMO_TILE_LIST: 'promo_tile_list',
  PROMO_DETAIL: 'promo_detail',
  RULES_LIST: 'rules_list',
  CURRENT_GAME_LIST: 'current_game_list',
  HISTORY_GAME_LIST: 'history_game_list',
  BONUS_WIDGET: 'bonus_widget',
  BIG_WIN_FEED: 'big_win_feed',
  SORT_POP_UP: 'sort_pop_up',
  WIDGET_PWA: 'widget_pwa',
};

export const ANALYTICS_SCREEN_AREA_DETAILS = {
  CATEGORY: 'category',
  PROVIDER: 'provider',
  RELEVANCE_GAME: 'relevance_game',
  RECENT_GAME: 'recent_game',
  SLIDER: 'banner',
  THEME: 'theme',
  SEARCH: 'search',
  BONUS: 'bonus',
  PROMO: 'promo',
  SIMILAR_GAME: 'similar_game',
  OTHER_GAMES: 'other_games',
  PROVIDER_GAMES: 'provider_games',
  ALL_CATEGORY: 'all_category',
  ALL_THEME: 'all_theme',
  ALL_PROVIDER: 'all_provider',
  MAIN_PAGE: 'main_page',
  BONUS_PAGE_CLICK: 'bonus_page_click',
  FAVORITE_PAGE_CLICK: 'favorite_page_click',
  COLLECTING_GAMES: 'collecting_games',
  WAGERING_GAMES: 'wagering_games',
  FREE_SPINS_PAGE_CLICK: 'free_spins_page_click',
  HALL_OF_FAME_PAGE_CLICK: 'hall_of_fame_page_click',
  FAVORITE_GAMES: 'favorite_games',
  BUTTON: 'button',
  BONUS_TILE: 'bonus_tile',
  BONUS_DETAIL: 'bonus_detail',
  BONUS_BUTTON: 'bonus_button',
  CONTROL_BUTTON: 'control_button',
  FAST_SEARCH_INPUT: 'fast_search_input',
  SEARCH_INPUT: 'search_input',
  GAME_HEADER: 'game_header',
  GAME_FOOTER: 'game_footer',
  PREVIEW_ACTIONS: 'preview_actions',
  GAME_TILE: 'game_tile',
  GAME_OF_THE_DAY: 'game_of_the_day',
  CATEGORY_TILE: 'category_tile',
  THEME_TILE: 'theme_tile',
  PROVIDER_TILE: 'provider_tile',
  WAGERING_BUTTON: 'wagering_button',
  HOW_TO_PLAY: 'how_to_play',
  HALL_OF_FAME: 'hall_of_fame',
  PROMO_TILE: 'promo_tile',
  CROSS_SALE_WIDGET: 'cross_sale_widget',
  RULES: 'rules',
  CURRENT_GAME_TILE: 'current_game_tile',
  HISTORY_GAME_TILE: 'history_game_tile',
  BONUS_BUTTON_OPEN: 'bonus_button_open',
  DEPOSIT_BUTTON: 'deposit_button',
  MY_RESULT: 'my_result',
  SORT_BUTTON: 'sort_button',
  RADIO_BUTTON: 'radiobutton',
  DOWNLOAD_BUTTON: 'download_button',
  PREVIEW_CURRENCY_CHANGE: 'preview_currency_change',
  PREVIEW_LOSS_LIMITS: 'preview_loss_limits',
  RANDOM_GAME: 'random_game',
  PROMO_WIDGET: 'promo_widget',
};

export const ANALYTICS_EVENT_DETAIL = {
  REMOVE_FROM_FAVORITE: 'remove_from_favorite',
  BONUS_TILE_CLICK: 'bonus_tile_click',
  HISTORY_BONUS_TILE_CLICK: 'history_bonus_tile_click',
  HISTORY_TO_ALL_BONUSES: 'history_to_all_bonus',
  TO_BONUS_COLLECTING_GAMES: 'to_bonus_collecting_games',
  TO_BONUS_WAGERING_GAMES: 'to_bonus_wagering_games',
  TO_BONUS_COLLECTING_GAMES_FREE_SPINS: 'to_bonus_collecting_games_free_spins',
  ALL_BONUSES: 'to_all_bonus',
  ACTIVATE_BONUS: 'activate_bonus',
  CANCEL_BONUS_CLICK: 'cancel_bonus_click',
  CANCEL: 'cancel',
  APPLY: 'apply',
  TOP_GAMES: 'top_games',
  RELEVANCE_GAME: 'relevance_game',
  FULLSCREEN: 'fullscreen',
  FULLSCREEN_OFF: 'fullscreen_off',
  CLOSE_GAME: 'close_game',
  PLAY_REAL_GAME: 'play_real_game',
  READ_MORE_RULES: 'read_more_rules',
  COLLECTING_GAME: 'collecting_game',
  CANCEL_BONUS_CLICK_CONFIRM: 'cancel_bonus_click_confirm',
  CANCEL_BONUS_CLICK_CANCEL: 'cancel_bonus_click_cancel',
  CURRENT: 'current_month',
  HISTORY: 'history_month',
  LOGIN: 'login',
  PROMO_TILE_NAME: 'promo_tile_name',
  OPEN_RULES: 'open_rules',
  CLOSE_RULES: 'close_rules',
  CURRENT_BONUS: 'current',
  HISTORY_BONUS: 'history',
  WIN: 'win',
  MEGA_WIN: 'mega_win',
  TAKE_CASHBACK: 'take_cashback',
  REGISTRATION: 'registration',
  MAKE_DEPOSIT_BONUS_CLICK: 'make_deposit_bonus_click',
  WAGERING_GAME: 'wagering_game',
  CUSTOMER_SUPPORT: 'customer_support',
  TO_THE_BONUS_DETAIL_CLICK: 'to_the_bonus_detail_click',
  OPEN_SORT_CLICK: 'open_sort_click',
  CURRENT_GAME_CLICK: 'current_game_tile',
};

export const ANALYTICS_DEFAULT_WAGERING = 'all';
